import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "trialsMenu",
    "casesMenu",
    "usersMenu",
    "auditMenu",
    "workstationMenu",
    "portalMenu",
    "trialSettingsMenu"
  ];

  toggleTrials(event) {
    event.preventDefault();
    this.trialsMenuTarget.classList.toggle("hidden");
  }

  toggleCases(event) {
    event.preventDefault();
    this.casesMenuTarget.classList.toggle("hidden");
  }

  toggleUsers(event) {
    event.preventDefault();
    this.usersMenuTarget.classList.toggle("hidden");
  }

  toggleAudit(event) {
    event.preventDefault();
    this.auditMenuTarget.classList.toggle("hidden");
  }

  toggleWorkstation(event) {
    event.preventDefault();
    this.workstationMenuTarget.classList.toggle("hidden");
  }

  togglePortal(event) {
    event.preventDefault();
    this.portalMenuTarget.classList.toggle("hidden");
  }

  toggleTrialSettings(event) {
    event.preventDefault();
    this.trialSettingsMenuTarget.classList.toggle("hidden");
  }
}
